module.exports = __webpack_public_path__ + "static/media/03.cfeb076b.jpg";